import React, { lazy } from "react";

const LazyAgentWork = lazy(() => import("./AgentWork"));

const AgentWork = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyAgentWork {...props} />;

export default AgentWork;
